<template>
  <div>
    <dx-data-grid
      :show-borders="true"
      :ref="'batch-child-grid-' + templateData.key"
      :columns="gridColumns"
      :data-source="dataSource"
      @row-removed="onRowRemoved"
      @cell-prepared="onCellPrepared"
    >
      <DxSearchPanel :visible="false" />
      <template #use-by-cell-template="{ data }">
        <gc-friendly-date :date="data.data.UseByDate" />
      </template>

      <template #qtyEditTemplate="{ data: cellInfo }">
        <div>
          <div>
            <DxNumberBox
              :value="cellInfo.value"
              @value-changed="onQuantityChanged($event, cellInfo)"
              class="gc-grid-number-box-editor"
              :format="getDecimalFormatByCode(2).Format"
            />
          </div>
        </div>
      </template>

      <template #batchNoEditTemplate="{ data: cellInfo }">
        <div>
          <div>
            <DxTextBox
              :value="cellInfo.value"
              @value-changed="onBatchNoChanged($event, cellInfo)"
              class="gc-grid-number-box-editor"
              :max-length="20"
            />
          </div>
        </div>
      </template>

      <template #batchEditTemplate="{ data: cellInfo }">
        <div>
          <div>
            <DxTextBox
              :value="cellInfo.value"
              @value-changed="onBatchChanged($event, cellInfo)"
              class="gc-grid-number-box-editor"
              :max-length="20"
              :disabled="templateData.data.IsBatchProduct == 'NextNo'"
            />
          </div>
        </div>
      </template>

      <template #useByDateEditTemplate="{ data :cellInfo}">
        <div>
          <div>
            <DxDateBox
              :value="cellInfo.value"
              @value-changed="onDateChanged($event, cellInfo)"
              display-format="dd MMM yyyy"
              class="gc-grid-number-box-editor"
            />
          </div>
        </div>
      </template>

      <DxEditing
        v-if="isEditable"
        :allow-deleting="true"
        :allow-updating="true"
        mode="cell"
      />
    </dx-data-grid>
  </div>
</template>
<script>
import { DxDataGrid } from "devextreme-vue/data-grid";
import { alert } from "devextreme/ui/dialog";
import BaseViewMixin from "../../src/v1/_mixins/base.view";

let baseLineBase = {
  BatchNo: "",
  SupplierBatchNo: "",
  SupplierCode: "",
  UseByDate: null,
  SupplierBatchReceivedQty: 0,
};

export default {
  components: { DxDataGrid },
  props: {
    isEditable: Boolean,
    showAdd: Boolean,
    templateData: {
      type: Object,
      default: () => {},
    },
    parentModel: {
      type: Object,
      default: () => {},
    },
    columns: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  mixins: [BaseViewMixin],
  data() {
    return {
      dataSource: this.templateData.data.GoodsInProductBatches,
    };
  },
  created() {
    if (this.dataSource.length == 0) this.onAddClickHandler();
  },
  methods: {
    onQuantityChanged(valueChangedArgs, cellInfo) {
      this.dataSource[cellInfo.rowIndex].SupplierBatchReceivedQty =
        valueChangedArgs.value;
      this.dataSource[cellInfo.rowIndex].ReceivedQty =
        this.dataSource[cellInfo.rowIndex].ActualStockConversion *
        this.dataSource[cellInfo.rowIndex].SupplierBatchReceivedQty;
      this.recalculateTotal();
    },
    onDateChanged(valueChangedArgs, cellInfo) {
      this.dataSource[cellInfo.rowIndex].UseByDate = valueChangedArgs.value;
    },
    onBatchNoChanged(valueChangedArgs, cellInfo) {
      this.dataSource[cellInfo.rowIndex].SupplierBatchNo =
        valueChangedArgs.value;
    },
    onBatchChanged(valueChangedArgs, cellInfo) {
      this.dataSource[cellInfo.rowIndex].BatchNo = valueChangedArgs.value;
    },
    onCellPrepared(e) {
      if (e.rowType === "data" && e.columnIndex == 0) {
        if (this.templateData.data.IsBatchProduct == "NextNo") {
          e.cellElement.classList.remove("gc-editor-cell");
        }
      }
    },
    onRowRemoved(e) {
      this.templateData.data.Qty -= e.data.SupplierBatchReceivedQty;
    },
    formatNumber(number) {
      return Number(parseFloat(number).toFixed(2)).toLocaleString("en", {
        minimumFractionDigits: 2,
      });
    },
    recalculateTotal() {
      let totalBatchPickedQty = 0;
      this.dataSource.forEach((x) => {
        totalBatchPickedQty += x.SupplierBatchReceivedQty;
      });

      // this.$logger.debug("totalBatchPickedQty", totalBatchPickedQty);

      this.templateData.data.Qty = totalBatchPickedQty;

      if (
        totalBatchPickedQty > this.templateData.data.SupplierOutstandingQuantity
      ) {
        this.$nextTick(function() {
          let result = alert(
            `Item : ${
              this.templateData.data.ItemDescription
            } has a received quantity of ${this.formatNumber(
              this.templateData.data.Qty
            )} which is more than the outstanding quantity of ${this.formatNumber(
              this.templateData.data.SupplierOutstandingQuantity
            )}.`,
            "Validation Errors"
          );
          // eslint-disable-next-line no-unused-vars
          result.then((dialogResult) => {
            // eslint-disable-next-line no-console
            // this.$logger.debug(dialogResult);
          });
        });
      }

      this.templateData.data.Completed =
        this.templateData.data.Qty >=
        this.templateData.data.SupplierOutstandingQuantity;
    },

    onAddClickHandler() {
      //   let grid = this.$refs["batch-child-grid"].instance;

      //   let count = this.dataSource.length;
      baseLineBase.ActualStockConversion = this.templateData.data.SupplierConversion;
      // baseLineBase.Comment = this.templateData.data.Comment;
      baseLineBase.ReceivedQty = this.templateData.data.ReceivedQty;

      this.dataSource.push(Object.assign({}, baseLineBase));

      //   setTimeout(() => {
      //     grid.editCell(count, 0);
      //     grid.repaint();
      //   }, 100);

      // this.$logger.debug("new line inserting", this.dataSource);
    },
  },
  computed: {
    noOfRecords() {
      return this.dataSource.length;
    },
    gridColumns() {
      let result = [...this.columns];
      if (this.isEditable)
        result.push({
          gcLabel: "",
          gcType: "String",
          type: "buttons",
          width: 110,
          buttons: [
            "delete",
            {
              hint: "Add Batch Line",
              icon: "plus",
              visible: this.isEditable,
              onClick: this.onAddClickHandler.bind(this),
            },
          ],
        });
      return result;
    },
  },
  watch: {
    noOfRecords: {
      handler: function(value) {
        // add a record if the no of items in the datasource is 0
        if (this.isEditable && value == 0) {
          this.onAddClickHandler();
        }
      },
    },
  },
};
</script>
<style>
.master-detail-caption {
  padding: 0 0 5px 10px;
  font-size: 14px;
  font-weight: bold;
}
</style>
